import React, { useEffect } from "react";
import { useHistory } from "react-router-dom";
import "./NotFound.css";

export default function NotFound() {
  const history = useHistory();

  useEffect(() => {
    // Redirect to home page after showing message briefly
    const timer = setTimeout(() => {
      history.push("/");
    }, 1500);

    return () => clearTimeout(timer);
  }, [history]);

  return (
    <div className="NotFound">
      <h3>Page not found! Redirecting to home...</h3>
    </div>
  );
}